export const PaymentReminderTestID = 'PaymentReminder.TestID';
export const ReminderSuccessContentTestID = 'ReminderSuccess.ContentTestID';
export const SendReminderContentTestID = 'SendReminder.ContentTestID';
